import React from "react";
import Home from "../../Components/Home/home";
import About from "../../Components/About/about";
import Service from "../../Components/Service/service";
import Project from "../../Components/Project/project";
import Contact from "../../Components/Contact/contact";

const Content = () => {
  return (
    <>
      <div className="main-content">
        <Home/>
        <About />
        <Service />
        <Project />
        <Contact />
      </div>
    </>
  );
};

export default Content;
